import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { ReactComponent as CarCharterIcon } from 'icons/car-charter-filled-icon.svg';

import { AreaCharter, Button, InputField, SelectFieldAdditionalItem, TableWrapper } from 'components/Global';
import DetailSewa from './detail-sewa';
import { useDispatch, useSelector } from 'react-redux';
import { checkEmptyObject, setCurrency } from 'utils/functionality';
import DetailPenyewa from './detail-penyewa';
import DetailHari from './detail-hari';
import { fetchOrderById, fetchSummaryOrder } from 'features/orders/actions';
import { getOrderAddon } from 'features/addon/actions';
import { useAppContext } from 'components/Context/AppContext';
import { getAllRentalLocation, getRentalLocationByServices } from 'features/rental-location/actions';
import { getServices } from 'features/services/actions';
import { addDays, format, parseISO, subHours } from 'date-fns';
import moment from 'moment-timezone';
import { updateApprovalOrder } from 'features/approvals/actions';
import { trackEvent } from 'utils/analytics';

const paymentType = [
  {
    id: 'pyt1',
    name: 'Pembayaran Full',
    value: 'FULL',
  },
  {
    id: 'pyt2',
    name: 'Pembayaran DP',
    value: 'HALF',
  },
];

const initialState = {
  order_type_id: 8,
  user_name: '',
  phone_number: '',
  wa_number: '',
  phone_country_code: '+62',
  email: '',
  type: '',
  remainder: 0,
  down_payment: 0,
  currency: 'IDR',
  order_detail: {
    vehicle: {},
    is_take_from_rental_office: false,
    end_booking_date: '',
    end_booking_time: '',
    start_booking_date: '',
    start_booking_time: '',
    rental_delivery_location: '',
    rental_delivery_location_detail: '',
    rental_return_location: '',
    rental_return_location_detail: '',
    without_driver: false,
    passenger_number: 0,
    booking_zones: [],
    location_id: 0,
    loc_time_id: '',
    dp_rule_id: 0,
    baggage: 0,
    is_for_other_person: false,
    other_person_name: '',
    other_person_phone: '',
    other_person_email: '',
    other_person_phone_cc: '',
    sub_services_id: 0,
  },
  addons: [],
  fee_meet_greet_board: 0,
};

const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const EditOrder = ({ transactionKey, orderData: selectedOrderData, status, getFileName, imagePreviewHandler }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: additionalData } = useSelector((state) => state.addon);
  const { data: summaryOrderData } = useSelector((state) => state.summaryOrder);
  const { data: rentalServicesData } = useSelector((state) => state.services);
  const { data: rentalLocationData } = useSelector((state) => state.rentalLocation);
  const { singleUser: customer } = useSelector((state) => state.user);
  const approvalData = useSelector((state) => state.approvals.approvalSetting);

  const { setShowSpinner, showToast, setShowConfirmation } = useAppContext();

  const [orderData, setOrderData] = useState(initialState);
  const [rentalLocation, setRentalLocation] = useState(undefined);
  const [startRentDate, setStartRentDate] = useState('');
  const [durationRent, setDurationRent] = useState(0);
  const [selectedCar, setSelectedCar] = useState(undefined);
  const [allAreaCharter, setAllAreaCharter] = useState([]);
  const [allRentTime, setAllRentTime] = useState([]);
  const [selectedAdditionalItem, setSelectedAdditionalItem] = useState(undefined);
  const [luggage, setLuggage] = useState({ luggage: 0, suitcaseXl: 0 });
  const [passengers, setPassengers] = useState({ child: 0, adults: 0 });
  const [selectedPaymentType, setSelectedPaymentType] = useState('');
  const [mappedPaymentType, setMappedPaymentType] = useState(paymentType);
  const [dayDuration, setDayDuration] = useState([]);
  const [additionalList, setAdditionalList] = useState([]);

  const [additionalSearchInput, setAdditionalSearchInput] = useState('');

  const getSubserviceId = () => {
    const subServiceId = rentalServicesData
      ?.find((item) => item.name === 'Sewa Mobil')
      ?.sub_services?.find((item) => item.name === 'Daily')
      ?.facilities?.find((item) => item.name === 'Charter');

    return subServiceId?.id;
  };

  const allAreaCharterCheckingValidation = (areaCharters) => {
    const excludedProps = [
      'booking_end_time',
      'booking_start_time',
      'charter_duration',
      'startLocation',
      'endLocation',
      'sameLocation',
    ];
    return (
      areaCharters?.length !== 0 &&
      areaCharters.every((area) =>
        Object.entries(area)
          .filter(([key]) => !excludedProps.includes(key)) // buang prop yang dikecualikan
          // eslint-disable-next-line no-unused-vars
          .every(([__, val]) => {
            if (typeof val === 'string') {
              return val.trim() !== '';
            }

            return Boolean(val);
          }),
      )
    );
  };

  const getTotalPrice = (total, point, voucher) => {
    let finalPrice = total - point;
    const voucherValue = voucher?.length > 0 ? voucher[0].value : undefined;
    if (voucherValue) {
      finalPrice -= voucherValue;
    }
    return isNaN(finalPrice) ? 0 : finalPrice;
  };

  useEffect(() => {
    dispatch(getAllRentalLocation());
    dispatch(getServices());
  }, []);

  useEffect(() => {
    if (!rentalServicesData.length) return;

    const serviceSewaMobil = rentalServicesData.find((item) => item.name === 'Sewa Mobil');

    const service_id = serviceSewaMobil?.id;
    const sub_service_id = rentalServicesData
      ?.find((item) => item.id === service_id)
      ?.sub_services?.find((item) => item.name === 'Daily')?.id;

    dispatch(getRentalLocationByServices({ service_id, sub_service_id, facility_id: getSubserviceId() }));
  }, [rentalServicesData]);

  useEffect(() => {
    dispatch(fetchOrderById(transactionKey));
    dispatch(getOrderAddon(transactionKey));
  }, [transactionKey]);

  useEffect(() => {
    if (
      !selectedOrderData ||
      checkEmptyObject(selectedOrderData) ||
      !rentalLocationData ||
      rentalLocationData.length === 0
    )
      return;

    const selectedLocation = rentalLocationData.find((loc) => loc.id === selectedOrderData.order_detail.location_id);

    setRentalLocation(selectedLocation);
    setStartRentDate(new Date(selectedOrderData.order_detail.start_booking_date));
    setDurationRent(selectedOrderData.order_detail.booking_zones?.length ?? 0);
    setSelectedCar(selectedOrderData.order_detail.vehicle);
    setSelectedPaymentType(mappedPaymentType?.find((item) => item.value == selectedOrderData.type)?.id);
    setLuggage({ luggage: selectedOrderData.order_detail.baggage, suitcaseXl: 0 });
    setPassengers({
      adults: selectedOrderData.order_detail.adult_passenger,
      child: selectedOrderData.order_detail.child_passenger,
    });
    setSelectedAdditionalItem(additionalData);

    if (selectedOrderData.order_additional_fees !== null) {
      setAdditionalList(selectedOrderData.order_additional_fees);
    }

    setAllAreaCharter(selectedOrderData.order_detail.booking_zones ?? []);

    let newAllRentTime = [];

    if (selectedOrderData.order_detail.booking_zones) {
      newAllRentTime = [...selectedOrderData.order_detail.booking_zones].map((zone) => ({
        charter_duration: zone?.charter_duration ?? 0,
        booking_start_time: zone?.booking_start_time ?? '',
        booking_end_time: zone?.booking_end_time ?? '',
      }));
    }
    setAllRentTime(newAllRentTime);

    setOrderData({
      ...selectedOrderData,
      user_name: selectedOrderData.user_name,
      wa_number: selectedOrderData.wa_number,
      phone_number: selectedOrderData.wa_number,
      phone_country_code: selectedOrderData.phone_country_code,
      email: selectedOrderData.email,
      order_detail: {
        ...selectedOrderData.order_detail,
        start_booking_date: selectedOrderData.start_booking_date,
        end_booking_date: selectedOrderData.end_booking_date,
        start_booking_time: selectedOrderData.start_booking_time,
        end_booking_time: selectedOrderData.end_booking_time,
        vehicle: selectedOrderData.vehicle,
        adult_passenger: selectedOrderData.order_detail.adult_passenger,
        child_passenger: selectedOrderData.order_detail.child_passenger,
        baggage: selectedOrderData.order_detail.baggage,
        booking_zones: selectedOrderData.booking_zones,
      },
      type: selectedOrderData.type,
      addons: selectedOrderData.addons,
    });
  }, [selectedOrderData, rentalLocationData]);

  // GET SUMMARY
  useEffect(() => {
    if (
      !rentalLocation ||
      !orderData?.order_detail?.end_booking_date ||
      !orderData?.order_detail?.start_booking_date ||
      !allRentTime ||
      allRentTime.length === 0 ||
      !allAreaCharter ||
      allAreaCharter.length === 0 ||
      !selectedCar
    )
      return;

    const fetchSummary = async () => {
      const orderBookingZone = [...allAreaCharter]
        .map((area, index) => ({
          ...area,
          charter_duration: allRentTime[index]?.charter_duration?.duration,
          booking_start_time: allRentTime[index]?.booking_start_time,
          booking_end_time: allRentTime[index]?.booking_end_time,
        }))
        .map((area) => ({
          ...area,
          endLocation: undefined,
          startLocation: undefined,
          sameLocation: undefined,
        }));

      const serviceSewaMobil = rentalServicesData.find((item) => item.name === 'Sewa Mobil');

      const service_id = serviceSewaMobil?.id;
      const sub_service_id = rentalServicesData
        ?.find((item) => item.id === service_id)
        ?.sub_services?.find((item) => item.name === 'Daily')
        ?.facilities?.find((item) => item.name === 'Charter')?.id;

      let mappingAdditionalItem = [];

      if (selectedAdditionalItem) {
        for (let addItionalChild of selectedAdditionalItem) {
          const additionalObj = {
            id: addItionalChild.additional.id,
            varieties: [
              {
                id: addItionalChild.additional.varieties[0].id,
                quantity: addItionalChild.total,
              },
            ],
          };

          mappingAdditionalItem.push(additionalObj);
        }
      }

      const payload = {
        end_booking_date: orderData?.order_detail?.end_booking_date,
        end_booking_time: allRentTime[allRentTime?.length - 1]?.booking_end_time,
        start_booking_date: orderData?.order_detail?.start_booking_date,
        start_booking_time: allRentTime[0]?.booking_start_time,
        order_type_id: 8,
        vehicle_id: orderData?.order_detail?.vehicle_id,
        without_driver: 0,
        order_booking_zone: orderBookingZone,
        vehicle_category_id: selectedCar?.category?.id,
        pasengger_number: +orderData?.order_detail?.adult_passenger + +orderData?.order_detail?.child_passenger,
        overtime: 0,
        location_id: rentalLocation?.id,
        sub_services_id: sub_service_id,
        addons: mappingAdditionalItem,
      };

      try {
        const response = await dispatch(fetchSummaryOrder(payload));
        if (response.meta?.requestStatus === 'fulfilled') {
          return;
        }
        showToast({ type: 'error', message: 'Terjadi Kesalahan' });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        showToast({ type: 'error', message: 'Terjadi Kesalahan' });
      }
    };

    fetchSummary();
  }, [
    rentalLocation,
    orderData?.order_detail?.end_booking_date,
    orderData?.order_detail?.start_booking_date,
    allRentTime,
    allAreaCharter,
    selectedCar,
    selectedAdditionalItem,
  ]);

  useEffect(() => {
    if (!Object.keys(summaryOrderData).length) return;

    if (summaryOrderData.total_dp > 0) {
      const newPaymentType = paymentType.map((item) =>
        item.id == 'pyt2'
          ? {
              ...item,
              name: `${
                item.name.includes('%')
                  ? item.name
                  : summaryOrderData?.formula_percentage?.value
                  ? `${item.name} ${summaryOrderData.formula_percentage.value}%`
                  : item.name
              }`,
            }
          : item,
      );
      setMappedPaymentType(newPaymentType);
    } else if (summaryOrderData.total_dp === 0) {
      setMappedPaymentType((prev) => prev.filter((item) => item.id !== 'pyt2'));
      setSelectedPaymentType('pyt1');
    }
  }, [summaryOrderData]);

  useEffect(() => {
    if (status === 'loading') {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [status]);

  const backHandler = () => {
    navigate(-1);
  };

  const changeRentalLocationHandler = (location) => {
    setRentalLocation(location);
    setOrderData({
      ...orderData,
      order_detail: {
        ...orderData.order_detail,
        loc_time_id: location?.time_zone_identifier,
        location_id: location?.id,
      },
    });
  };

  const submitHandler = () => {
    const validLocation = rentalLocation !== undefined && !checkEmptyObject(rentalLocation);
    const validUsername = orderData?.user_name.replace(/\s/g, '').length !== 0;
    const validUserWaNumber = orderData?.wa_number.replace(/s/g, '').length !== 0;
    const validUserEmail = new RegExp(regexEmail).test(orderData?.email);
    const validStartBookingDate = orderData.order_detail.start_booking_date !== '';
    const validDurationRent = durationRent !== 0;
    const validRentTime =
      allRentTime?.length !== 0 &&
      allRentTime.every((time) => time.booking_start_time && time.booking_start_time.trim() !== '');
    const validVehicle = orderData.order_detail.vehicle_id !== '';
    const validRentCharterTime =
      allRentTime?.length !== 0 && allRentTime.every((time) => time.charter_duration !== undefined);
    const validPassengersAndLuggage =
      (orderData.order_detail.adult_passenger || orderData.order_detail.child_passenger) &&
      orderData.order_detail.baggage;
    const validAreaCharter = allAreaCharterCheckingValidation(allAreaCharter);

    if (
      !validLocation ||
      !validUsername ||
      !validUserWaNumber ||
      !validUserEmail ||
      !validStartBookingDate ||
      !validDurationRent ||
      !validRentTime ||
      !validVehicle ||
      !validRentCharterTime ||
      !validPassengersAndLuggage ||
      !validAreaCharter
    ) {
      return showToast({ type: 'warning', message: 'Harap Mengisi Semua Field!' });
    }

    const utcDifference = moment
      .tz(`${orderData.order_detail.start_booking_date}`, orderData.order_detail.loc_time_id)
      .format('Z')
      .split(':')[0];

    const convertStartBookingTimeUTC = subHours(
      parseISO(`${orderData.order_detail.start_booking_date} ${orderData.order_detail.start_booking_time}`),
      parseInt(utcDifference),
    );

    const convertEndBookingTimeUTC = subHours(
      parseISO(`${orderData.order_detail.end_booking_date} ${dayDuration[dayDuration.length - 1]?.booking_end_time}`),
      parseInt(utcDifference),
    );

    const orderBookingZone = [...allAreaCharter]
      .map((area, index) => {
        const areaDate = format(addDays(new Date(orderData.order_detail.start_booking_date), index), 'yyyy-MM-dd');

        const convertStartTimeUTC = subHours(
          parseISO(`${areaDate} ${allRentTime[index]?.booking_start_time}`),
          parseInt(utcDifference),
        );

        const convertEndTimeUTC = subHours(
          parseISO(`${areaDate} ${allRentTime[index]?.booking_end_time}`),
          parseInt(utcDifference),
        );

        return {
          ...area,
          charter_duration: allRentTime[index]?.charter_duration?.duration,
          booking_start_time: format(convertStartTimeUTC, 'HH:mm'),
          booking_end_time: format(convertEndTimeUTC, 'HH:mm'),
        };
      })
      .map((area) => ({
        ...area,
        endLocation: undefined,
        startLocation: undefined,
        sameLocation: undefined,
      }));

    const priceDifference = orderData.total_amount_order - summaryOrderData.total_payment;

    const payload = {
      reference_id: orderData.id,
      reference_type: 'order',
      approval_setting_id: approvalData.data[0].id,
      data: {
        ...orderData,
        disbursement: {
          ...orderData.disbursement,
          payment_method_id: 0,
          ppn_internal_percentage: 0,
          disbursement_confirmation_image: '',
          payment_platform_fee_type_fixed: 0,
          total_amount_customer_service_fee:
            orderData.total_amount_order === summaryOrderData.total_payment
              ? orderData.disbursement.total_amount_customer_service_fee
              : 0,
          total_amount_external_payment_fee:
            orderData.total_amount_order === summaryOrderData.total_payment
              ? orderData.disbursement.total_amount_external_payment_fee
              : 0,
          payment_platform_fee_type_percentage: 0,
          total_amount_with_customer_service_fee:
            orderData.total_amount_order === summaryOrderData.total_payment || priceDifference > 0
              ? orderData.disbursement.total_amount_with_customer_service_fee
              : 0,
          total_net_amount:
            orderData.total_amount_order === summaryOrderData.total_payment
              ? orderData.disbursement.total_net_amount
              : 0,
        },
        booking_price: summaryOrderData.booking_price,
        deposit: summaryOrderData.deposit,
        price_per_day: summaryOrderData.price_per_day,
        total_payment:
          orderData.total_amount_order === summaryOrderData.total_payment
            ? getTotalPrice(orderData?.total_payment, orderData?.point, orderData?.vouchers)
            : getTotalPrice(summaryOrderData?.total_payment, orderData?.point, orderData?.vouchers),
        deposit_e_toll: summaryOrderData.deposit_e_toll,
        outside_operational_charge: summaryOrderData.outside_operational_charge,
        one_day_order_charge: summaryOrderData.one_day_order_charge,
        exceed_passenger_price: summaryOrderData.exced_max_passenger_charge,
        over_time_price: summaryOrderData.over_time_price,
        over_time: summaryOrderData.over_time_hour,
        order_overtime_total_price: summaryOrderData.order_overtime_total_price,
        remainder: orderData.type === 'FULL' ? 0 : summaryOrderData.remainder,
        down_payment: orderData.type === 'FULL' ? 0 : summaryOrderData.total_dp,
        total_amount_order:
          orderData.total_amount_order === summaryOrderData.total_payment
            ? orderData.total_amount_order
            : summaryOrderData.total_payment,
        total_diff_price_with_approval: 0,
        order_detail: {
          ...orderData.order_detail,
          vehicle_id: selectedCar.id,
          booking_zones: orderBookingZone,
          start_booking_date: format(convertStartBookingTimeUTC, 'yyyy-MM-dd'),
          start_booking_time: format(convertStartBookingTimeUTC, 'HH:mm'),
          end_booking_date: format(convertEndBookingTimeUTC, 'yyyy-MM-dd'),
          end_booking_time: format(convertEndBookingTimeUTC, 'HH:mm'),
          vehicle: selectedCar,
        },
        order_additional_fees: additionalList,
        addon_total_price: summaryOrderData.addon_total_price,
        addons: summaryOrderData?.addons,
      },
    };

    setShowConfirmation({
      message: 'Apakah anda yakin ingin melanjutkan proses recalculate?',
      show: true,
      onClick: async () => {
        try {
          trackEvent('approval_decided', {
            order_id: payload?.data?.transaction_key,
            decision: 'approved',
            source: 'detail_order_car_charter_edit',
          });
          await dispatch(updateApprovalOrder(payload)).unwrap();
          showToast({ type: 'success', message: 'Approval recalculate berhasil dilakukan' });
          navigate(-1);
        } catch (err) {
          showToast({ type: 'error', message: 'Approval recalculate gagal dilakukan' });
        }
      },
    });
  };

  return (
    <div className="edit-car-charter">
      <div className="edit-car-charter__back-btn" onClick={backHandler}>
        <LeftArrow />
        <p>Kembali</p>
      </div>

      <TableWrapper
        icon={<CarCharterIcon fill="#009EF7" width="25px" height="25px" />}
        title="Car Charter"
        className="edit-car-charter__content-data"
      >
        <DetailPenyewa
          rentalLocationData={rentalLocationData}
          rentalLocation={rentalLocation}
          rentalLocationHandler={changeRentalLocationHandler}
          orderData={orderData}
          setOrderData={setOrderData}
          selectedOrderData={selectedOrderData}
          customer={customer}
          approvalUpdate
          getFileName={getFileName}
          imagePreviewHandler={imagePreviewHandler}
        />

        <DetailHari
          startRentDate={startRentDate}
          setStartRentDate={setStartRentDate}
          durationRent={durationRent}
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          allRentTime={allRentTime}
          setAllRentTime={setAllRentTime}
          orderData={orderData}
          setOrderData={setOrderData}
          setSelectedAdditionalItem={setSelectedAdditionalItem}
          setDurationRent={setDurationRent}
          dayDuration={dayDuration}
          setDayDuration={setDayDuration}
        />

        <DetailSewa
          allRentTime={allRentTime}
          orderData={orderData}
          setOrderData={setOrderData}
          rentalLocation={rentalLocation}
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          selectedLuggage={luggage}
          selectedPassengers={passengers}
          setSelectedLuggage={setLuggage}
          setSelectedPassengers={setPassengers}
          selectedPaymentType={selectedPaymentType}
          setSelectedPaymentType={setSelectedPaymentType}
          mappedPaymentType={mappedPaymentType}
          getSubserviceId={getSubserviceId}
        />

        <div className="edit-car-charter__content-data__area-charter">
          <h2>Detail Area Charter</h2>
          <AreaCharter
            durationRentDate={durationRent}
            startDate={startRentDate}
            forCustomOrder
            rentalLocation={rentalLocation}
            allAreaCharter={allAreaCharter}
            setAllAreaCharter={setAllAreaCharter}
          />
        </div>

        <div className="edit-car-charter__content-data__additional">
          <h2>Additional</h2>
          <div className="edit-car-charter__content-data__additional-form">
            <SelectFieldAdditionalItem
              label="Pilih Tambahan"
              id="tambahan"
              placeholder="Cari Perlengkapan Khusus.."
              selectedAdditionalItem={selectedAdditionalItem}
              setSelectedAdditionalItem={setSelectedAdditionalItem}
              value={additionalSearchInput}
              onChange={(e) => setAdditionalSearchInput(e.target.value)}
              data={additionalData?.data || []}
              disable={!additionalData || checkEmptyObject(additionalData)}
              filterParams={{
                locationId: rentalLocation?.id,
                locTimeId: rentalLocation?.time_zone_identifier,
                startDate: orderData.order_detail.start_booking_date,
                endDate: orderData.order_detail.end_booking_date,
                startTime: orderData.order_detail.start_booking_time + ':00',
                endTime: orderData.order_detail.end_booking_time + ':00',
              }}
            />

            <InputField
              label="Total Biaya Permintaan Khusus"
              placeholder="IDR 0"
              value={
                summaryOrderData?.addon_total_price && selectedAdditionalItem
                  ? setCurrency(summaryOrderData.addon_total_price)
                  : ''
              }
              disable
            />
          </div>
        </div>

        <div className="edit-car-charter__content-data__total-price">
          <div className="total-price-wrapper">
            <h3>Total</h3>
            <p>
              {setCurrency(
                getTotalPrice(summaryOrderData?.total_payment, orderData?.point, orderData?.vouchers),
                orderData?.currency,
              )}
            </p>
          </div>
        </div>

        <div className="edit-car-charter__content-data__btn-action">
          <Button
            type="button"
            variant="outline"
            width="165px"
            height="39px"
            size="md"
            className="button"
            onClick={backHandler}
          >
            Kembali
          </Button>
          <Button type="button" width="165px" height="39px" size="md" className="button" onClick={submitHandler}>
            Simpan
          </Button>
        </div>
      </TableWrapper>
    </div>
  );
};

export default EditOrder;
